import { createActions, createReducer } from 'reduxsauce'

import ExperienciaProfissional from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaExperienciaProfissionalInicio: [],
    buscaExperienciaProfissionalSucesso: ['experienciaProfissional'],
    buscaExperienciaProfissionalErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
}

// Ação para busca completa
Creators.buscaExperienciaProfissional = filtro => {
    return dispatch => {
        dispatch(Creators.buscaExperienciaProfissionalInicio())
        let serv = new ExperienciaProfissional()
        return serv
            .detalhesExperienciaProfissional(filtro)
            .then(response => dispatch(Creators.buscaExperienciaProfissionalSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaExperienciaProfissionalErro(error)))
    }
}

const buscaExperienciaProfissionalInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaExperienciaProfissionalErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaExperienciaProfissionalSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.experienciaProfissional.resultado, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EXPERIENCIA_PROFISSIONAL_INICIO]: buscaExperienciaProfissionalInicio,
    [Types.BUSCA_EXPERIENCIA_PROFISSIONAL_ERRO]: buscaExperienciaProfissionalErro,
    [Types.BUSCA_EXPERIENCIA_PROFISSIONAL_SUCESSO]: buscaExperienciaProfissionalSucesso,
})
